import React, { PropsWithChildren } from 'react';
import { Box, Grid, IconButton, Modal, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

interface CustomModalProps {
  open: boolean;
  onClose?: () => void;
  sx?: object;
  title?: string;
  subtitle?: string;
}

const CustomModal = ({ open, onClose, title, subtitle, sx, children }: PropsWithChildren<CustomModalProps>) => {
  return (
    <Modal open={open} onClose={onClose} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box
        sx={{
          backgroundColor: 'white',
          position: 'relative',
          borderRadius: '20px',
          padding: '50px',
          minWidth: '550px',
          width: '40vw',
          textAlign: 'center',
          overflowY: 'auto',
          ...sx,
        }}
      >
        <IconButton
          sx={{
            position: 'absolute',
            top: 15,
            right: 15,
            '@media print': {
              display: 'none',
            },
          }}
          onClick={() => onClose && onClose()}
        >
          <Close />
        </IconButton>
        <Grid container direction="column">
          {title && (
            <Grid item>
              <Typography variant="h3" mb={3} align="left">
                {title}
              </Typography>
            </Grid>
          )}
          {subtitle && (
            <Grid item>
              <Typography variant="h4" mb={3} align="left">
                {subtitle}
              </Typography>
            </Grid>
          )}
          {children}
        </Grid>
      </Box>
    </Modal>
  );
};

export default CustomModal;
